<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'App',
  updated () {
    this.initWx()
  },
  created () {
    this.initWx()
  },
  mounted () {
    if (this.isMobile() && this.$route.path === '/') {
      this.$router.replace('/home')
    }
    if (!this.isMobile() && this.$route.path === '/home') {
      this.$router.replace('/')
    }
    window.onresize = () => {
      if (this.isMobile() && this.$route.path === '/') {
        this.$router.replace('/home')
      }
      if (!this.isMobile() && this.$route.path === '/home') {
        this.$router.replace('/')
      }
    }
  },
  methods: {
    isMobile () {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    initWx () {
      if (/micromessenger/i.test(navigator.userAgent)) {
        let url = window.location.href
        axios.get(`https://mainssl.geekpark.net/api/v1/wechat/js_config?request_url=${encodeURIComponent(url)}`)
          .then((response) => {
            let json = response.data
            let wx = window.wx
            wx.config({
              debug: false,
              appId: json.appId,
              timestamp: json.timestamp,
              nonceStr: json.nonceStr,
              signature: json.signature,
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
            })

            let imgUrl = 'https://summit-img.geekpark.net/ifx-icon.png'
            let desc = 'GeekPark IF X\n2019.12.20-12.22\n751D·PARK 北京时尚设计广场'
            let title = '极客公园创新大会十周年'

            wx.ready(function () {
              wx.onMenuShareTimeline({ // 分享朋友圈
                title: title, // 分享标题
                link: url, // 分享链接
                imgUrl: imgUrl // 分享图标
              })
              wx.onMenuShareAppMessage({ // 分享给好友
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: url, // 分享链接
                imgUrl: imgUrl // 分享图标
              })
            })
          })
      }
    }
  }
}
</script>
<style lang="less">
  @font-face {
    font-family: SyncopateBold;
    src: url('https://summit-img.geekpark.net/ifx/fontsSyncopate-Bold.ttf');
  }
  * {
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
    backface-visibility: hidden;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
  }

  .vjs-poster {
    background-size: cover !important;
  }
</style>
